/* eslint-disable no-secrets/no-secrets */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { QuestionSetComponent, platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import appConfig from 'app-config';
import { MLModalService } from 'ml-portals-services-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLErrorMessageUtil } from 'ml-portals-util-js';
import {
    PriorInsuranceComponent,
    PriorMetSubmissionPopup,
    PriorMetSubmissionPopupMessages,
    PriorMetSubmissionPopupStyles
} from 'ml-capability-quoteandbind-common-react';
import {MLUWIssuesPanelComponent} from "gw-capability-gateway-quoteandbind-common-react";
import HOTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';

import { UserService } from 'gw-capability-gateway';
import messages from './HOAdditionalInfoToQuote.messages';
import metadata from './HOAdditionalInfoToQuote.metadata.json5';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import EsignatureComponent from 'gw-capability-quoteandbind-common-react/components/EsignatureComponent/EsignatureComponent';

const questionsToShow = ['HOPRentHome_ML', 'HOPBusinessHome_ML', 'HOPHasTrampoline_ML', 'HOPBusinessPursuitsCoverage_ML',
    'HOPOwnPropertyDiffLocation_ML', 'HOPRentMoreThan30DaysPerYear_ML', 'HOPSubscriptionPayments_ML'];

const _filterQuestionSet = (qs) => {
    qs.answers = Object.keys(qs.answers)
        .filter((key) => questionsToShow.includes(key))
        .reduce((obj, key) => {
            obj[key] = qs.answers[key];
            return obj;
        }, {});
};

// ML: MLHOAddtlInfoToQuoteCtrl.js, ml-ho-addtl-info-to-quote.html

function HOAdditionalInfoToQuote(props) {
    const modalApi = useModal();
    const isGPA = appConfig.portalCode === 'GPA';
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();

    const {
        wizardData: submissionVM, updateWizardData, goNext, currentStep, isSkipping, history, steps
    } = props;

    const {nextStepVisited, canShowReturnToQuoteButton} = MLWizardNavUtil(props);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    const { onValidate, isComponentValid , initialValidation} = useValidation('HOAdditionalInfoToQuote');
    const [showErrors, setShowErrors] = useState(false);
    const [priorInsuranceErrors_Ext, setPriorInsuranceErrors_Ext] = useState([]);
    const [showPriorInsuranceErrors_Ext, setShowPriorInsuranceErrors_Ext] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const [disableReturnToQuoteButton, setDisableReturnToQuoteButton] = useState(false)

    // init
    const quoteID = submissionVM.quoteID.value;
    const hoModel = submissionVM.lobData.homeowners.value;
    const priorInsuranceQuestionSetData = _.get(submissionVM.lobData.homeowners, 'priorInsurance.value[0]');
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(false);
    const [blockingUwIssues, setBlockingUwIssues] = useState([]);
    const [disableNextButton, setDisableNextButton] = useState(false);
    const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
    const BOOKROLL_QUOTE_ASSIST = "quote_assist" 
    const BOOKROLLTYPE_QUOTE_ASSIST = "quote_assist"
    const BOOKROLLTYPE_CAREER_BOOK_TRANSFER = 'carrier_book_transfer';
    const BOOKROLLTYPE_INDEPENDENT_AGENT_BOOKROLL = 'independent_agent_book_roll';
    const invalidBookRollTypeCombination = ['MultLineCurrentInsuranceProviderNoPriorInsurance_Ext', 'MultLineCurrentInsuranceProviderFarmers_Ext']

    const checkForAdditionalInfoUwIssues = useCallback(() => {
        const uwIssues = submissionVM.errorsAndWarnings?.underwritingIssues?.value;
        if (uwIssues?.length > 0) {
            const preQuoteCheckpointIssues = uwIssues.filter((issue) => {
                return (issue.checkingSet_Ext === 'PreQuote'|| issue.checkingSet_Ext === 'Question') && issue.currentBlockingPoint === 'BlocksQuote';
            });
            if (preQuoteCheckpointIssues?.length > 0) {
                setIsUWIssuesPanelVisible(true);
                setBlockingUwIssues(preQuoteCheckpointIssues);
                setDisableNextButton(true);
                return true;
            }
            setDisableNextButton(false);
            return false;
        }
        return false;
    }, [submissionVM]);

    const checkForDisableNextButton = useCallback((issues) => {
        if (issues?.length > 0) {
            const prequoteCheckpointIssues = issues.filter((issue) => {
                return issue.checkingSet_Ext === 'PreQuote' && issue.currentBlockingPoint === 'BlocksQuote';
            });
            setDisableNextButton(prequoteCheckpointIssues?.length > 0);
        }
    }, []);

    const checkForInvalidBookrollCombination = () => {
      setDisableReturnToQuoteButton(false);
      clearBlockAlerts("InvalidInsuranceProviderForBookRoll");
      const insurerAnswer = _.get(
        priorInsuranceQuestionSetData,
        "answers.MultLineCurrentInsuranceProvider_Ext",
      );
      const isBookRoll = _.get(submissionVM, "bookrollInd_ML.value.code");
      const bookRollType = _.get(submissionVM, "bookRollType_Ext.value.code");
      if (
        isBookRoll !== undefined &&
        isBookRoll !== null &&
        (isBookRoll === BOOKROLL_WITHOUT_RATE_CAPPING || isBookRoll === BOOKROLL_QUOTE_ASSIST) &&
        bookRollType !== undefined &&
        bookRollType !== null &&
        (bookRollType === BOOKROLLTYPE_CAREER_BOOK_TRANSFER ||
          bookRollType === BOOKROLLTYPE_INDEPENDENT_AGENT_BOOKROLL ||
          bookRollType === BOOKROLLTYPE_QUOTE_ASSIST
        ) &&
        invalidBookRollTypeCombination.includes(insurerAnswer)
      ) {
        setDisableReturnToQuoteButton(true);
        return true;
      }
      return false;
    };

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'HO Additional Info Page'});
            });
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []);

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    useEffect(() => {
        clearBlockAlerts('priorInsuranceErrors');
        if (showPriorInsuranceErrors_Ext === true) {
            priorInsuranceErrors_Ext.forEach((error) => {
                addErrorAlert(error, 'priorInsuranceErrors');
                window.scrollTo(0, 0);
            });
        }
    }, [showPriorInsuranceErrors_Ext])

    const dwellingInfoQuestionSetData = _.get(submissionVM.lobData.homeowners, 'dwellingAdditionalInfo.value[0]');
    const filteredDwellingInfoQuestionSetData = _.clone(dwellingInfoQuestionSetData);
    if (filteredDwellingInfoQuestionSetData) {
        _filterQuestionSet(filteredDwellingInfoQuestionSetData);
    }

    const checkQuestionSetSync = (serviceCall) => {
        let updatePromise;
        if (questionSetSyncing && questionSetSyncPromise) {
            console.log("Waiting for questionSetSyncing to finish...")
            updatePromise = questionSetSyncPromise.then(() => {
                let promise = serviceCall();
                setTimeout(() => {
                    showProgressDialog(platformMessages.syncingQuestions, promise, true);
                }, 0);
                return promise;
            });
        } else {
            updatePromise = serviceCall();
            setTimeout(() => {
                showProgressDialog(platformMessages.syncingQuestions, updatePromise, true);
            }, 0);
        }

        setQuestionSetSyncing(true);
        setQuestionSetSyncPromise(updatePromise);
        return updatePromise;
    };

    const syncPriorInsuranceQuestionSets = useCallback(() => {
        // const scrollPositionBeforeUpdate = window.pageYOffset;
        const syncPromise = checkQuestionSetSync(() => LoadSaveService.syncQuestionSetML(quoteID, [priorInsuranceQuestionSetData], authHeader));
        // const numberAlertsBeforeUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
        syncPromise.then((updatedQuestionSets) => {
            const priorInsuranceQs = updatedQuestionSets.find((q) => q.code === 'PriorInsuranceMultiLine_Ext');
            _.set(submissionVM, 'lobData.homeowners.priorInsurance.value[0]', priorInsuranceQs);
            if(checkForInvalidBookrollCombination()){
                const message = translator(messages.InvalidInsuranceProviderForBookRoll);
                addErrorAlert(message, 'InvalidInsuranceProviderForBookRoll');
                window.scrollTo(0, 0);
                setDisableReturnToQuoteButton(true)
            }
            // setTimeout(() => {
            //     const numberAlertsAfterUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
            //     if (!(numberAlertsAfterUpdate > numberAlertsBeforeUpdate)) {
            //         // If no alerts have been added we want to scroll back to the position the user was at before the Question Set update
            //         // as the height of the container containing the Question Set may change. If an alert has been added
            //         // we wish to scroll to the top of the screen - this will happen automatically when addAlert() is called in MLAlertService
            //         window.scrollTo(0, scrollPositionBeforeUpdate);
            //     }
            // });

            updateWizardData(submissionVM);
            refreshData();
        }).finally(() => {
            setQuestionSetSyncing(false);
            setQuestionSetSyncPromise(null);
            setDisableNextButton(false);
        });
    }, [authHeader, checkQuestionSetSync, priorInsuranceQuestionSetData, quoteID, refreshData, submissionVM, updateWizardData]);

    const syncDwellingInfoQuestionSets = (qsQuestionType) => {
        // const scrollPositionBeforeUpdate = window.pageYOffset;
        const syncPromise = checkQuestionSetSync(() => LoadSaveService.syncQuestionSetML(quoteID, [filteredDwellingInfoQuestionSetData], authHeader));
        // const numberAlertsBeforeUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
        syncPromise.then((updatedQuestionSets) => {
            const dwellingQs = updatedQuestionSets.find((q) => q.code === 'HOPDwellingAddlInfo_ML');
            _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', dwellingQs);
            // setTimeout(() => {
            //     const numberAlertsAfterUpdate = alertHelper.getNumberOfAlertsInAlertGroup();
            //     if (!(numberAlertsAfterUpdate > numberAlertsBeforeUpdate)) {
            //         // If no alerts have been added we want to scroll back to the position the user was at before the Question Set update
            //         // as the height of the container containing the Question Set may change. If an alert has been added
            //         // we wish to scroll to the top of the screen - this will happen automatically when addAlert() is called in MLAlertService
            //         window.scrollTo(0, scrollPositionBeforeUpdate);
            //     }
            // });

            updateWizardData(submissionVM);

            setQuestionSetSyncing(false);
            setQuestionSetSyncPromise(null);
            setDisableNextButton(false);

            refreshData();
        });
    };

    const showNameField = () => {
        return hoModel.coverables.disclosures_ML.losses.some((c) => c.nameInsured);
    };

    const onChangeTypes = ['Boolean', 'Choice', 'Integer'];
    const onDwellingInfoValueChange = (aQuestionSetAnswersValue, pathToAnswers, qsQuestionType) => {
        if (onChangeTypes.includes(qsQuestionType)) {
            // RadioButton has no onBlur event
            syncDwellingInfoQuestionSets(qsQuestionType);
        } else {
            // use onBlur for other Input fields
            _.set(submissionVM, 'lobData.homeowners.dwellingAdditionalInfo.value[0]', aQuestionSetAnswersValue);
            refreshData();
        }
    };

    const onBlur = (evt, object, qsQuestionType) => {
        // check if progress dialog is causing the onBlur event and if so, do not trigger another sync call
        const isTargetModal = evt?.relatedTarget?.className?.indexOf('ml-modal-loading') > -1;
        if (!onChangeTypes.includes(qsQuestionType) && !isTargetModal) {
            // DropdownField component triggers onBlur event but syncQuestionSet should be performed in onValueChange
            syncDwellingInfoQuestionSets(qsQuestionType);
        }
    };

    const isPriorInsuranceMetOrFarmers = () => {
        const answers = _.get(priorInsuranceQuestionSetData,"answers.MultLineCurrentInsuranceProvider_Ext");
        return (answers === 'MultLineCurrentInsuranceProviderFarmers_Ext' || answers === 'MultLineCurrentInsuranceProviderMetLifePropCas_Ext');
    };

    const onUpdateErrors_Ext = useCallback((val) => {
        setPriorInsuranceErrors_Ext(val);
    }, []);

    const showPriorMetSubmissionModal = () => {
        const disableButton = () => {
            return _.isUndefined(_.get(submissionVM, 'baseData.newPolicyReason_Ext.value', undefined));
        };

        const mapAvailableValues = (values) => {
            if (submissionVM.isSubmitAgent.value === true) {
                values = values.filter((reason) => reason.code !== 'purchase_direct');
            }

            return values.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const newPolicyReasonHelpTextMap = {
            insuring_same_location_diff_policy_form: translator(PriorMetSubmissionPopupMessages.sameLocationPriorMetTooltipContent)
        };

        const newPolicyReasonHelpTextTitleMap = {
            insuring_same_location_diff_policy_form: translator(PriorMetSubmissionPopupMessages.sameLocationPriorMetTooltipTitle)
        };

        const onSaveAction = async (baseDataVM) => {
            try {
                showProgressDialog(platformMessages.saveSubmission);
                const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM?.value, authHeader);
                _.set(submissionVM, 'value', submissionData);
                updateWizardData(submissionVM);

                setIsUWIssuesPanelVisible(false);
                if (checkForAdditionalInfoUwIssues()) {
                    return false;
                }

                goNext();
                return true;
            } catch (error) {
                MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
            } finally {
                hideProgressDialog();
            }

        };

        const overrides = {
            newPolicyReasonRadioButtons: {
                helpTextTitleMap: newPolicyReasonHelpTextTitleMap,
                helpTextMap: newPolicyReasonHelpTextMap,
                availableValues: mapAvailableValues(_.get(submissionVM, 'baseData.newPolicyReason_Ext.aspects.availableValues', [])),
                value: _.get(submissionVM, 'baseData.newPolicyReason_Ext.value')
            }
        };

        const componentProps = {
            title: translator(PriorMetSubmissionPopupMessages.priorMetPopupHeader),
            uiProps: PriorMetSubmissionPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            viewModel: submissionVM.baseData,
            disableButton: disableButton,
            modalBodyStyles: PriorMetSubmissionPopupStyles,
            overrideProps: overrides,
            onSaveAction: onSaveAction,
            showXCloseButton: false
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const checkReadOnlyAnswer = (key) => {
        return false;
    };
    
    const nextStepText_Ext = () => {
        return (
            <FormattedMessage
                {...messages.continueText}
                values={{
                    claimInformation: (
                        <strong>{translator(messages.claimInformation)}</strong>
                    )
                }}
            />
        );
    };

    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        if (!isComponentValid) {
            setShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        if (priorInsuranceErrors_Ext.length !== 0) {
            setShowPriorInsuranceErrors_Ext(true);
            return false;
        }

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }
        
        return true;
    }, [authHeader, currentStep.mlStepName, errorTimestamp, isComponentValid, priorInsuranceErrors_Ext.length, submissionVM]);

    const onNext = async () => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'HO Additional Info Page', action: 'HO Additional Page Submitted'});
            });
        }

        if(checkForInvalidBookrollCombination()){
            const message = translator(messages.InvalidInsuranceProviderForBookRoll);
            addErrorAlert(message, 'InvalidInsuranceProviderForBookRoll');
            window.scrollTo(0, 0);
            setDisableReturnToQuoteButton(true)
            return false;
        }

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'hoDisclosureToQuote', authHeader);
        if (isPriorInsuranceMetOrFarmers()) {
            showPriorMetSubmissionModal();
            return false;
        } else {
            try{
                showProgressDialog(platformMessages.saveSubmission);
                const submissionData = await LoadSaveService.updateDraftSubmission(submissionVM?.value, authHeader);
                _.set(submissionVM, 'value', submissionData);
                updateWizardData(submissionVM);

                setIsUWIssuesPanelVisible(false);
                if (checkForAdditionalInfoUwIssues()) {
                    return false;
                }
            } catch (error) {
                if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                    showErrorModal(null, messages.somethingWentWrong)
                }
            } finally {
                hideProgressDialog();
            }
        }

        if (!nextStepVisited()) {
            return submissionVM;
        }
        goNext();
        return false;
    };

    const resolvers = {
        resolveComponentMap: {
            priorinsurancecomponent: PriorInsuranceComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent,
            questionset: QuestionSetComponent,
            esignatureComponent: EsignatureComponent
        },
        resolveCallbackMap: {
            onNext
        }
    };

    const overrideProps = {
        priorInsuranceComponent: {
            submissionVM: submissionVM,
            updateWizardData: updateWizardData,
            onValidate: onValidate,
            onUpdateErrors: onUpdateErrors_Ext,
            syncQuestionSets: syncPriorInsuranceQuestionSets,
            showPriorInsuranceErrors: showPriorInsuranceErrors_Ext,
            updateShowPriorInsuranceErrors: setShowPriorInsuranceErrors_Ext,
            showErrors,
            isGpa: true
        },
        dwellingQuestionSet: {
            value: filteredDwellingInfoQuestionSetData,
            onValueChange: onDwellingInfoValueChange,
            onBlur,
            onValidate,
            showErrors,
            checkReadOnlyAnswer
        },
        nameCellHeader: {
            visible: showNameField()
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        stickyfootercomponent: {
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext,
            showReturnToQuote
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: true
        },
        nextButton: {
            disabled: disableNextButton
        },
        uwIssueContainer: {
            visible: isUWIssuesPanelVisible,
            uwIssues: blockingUwIssues,
            jobID: submissionVM.quoteID.value,
            publicID: _.get(submissionVM, 'value.publicID'),
            afterIssuesRefreshedCallback: checkForDisableNextButton,
            submissionVM,
            history
        },
        esignContainer: {
            visible: isModernProduct,
            model: submissionVM,
            updateWizardData,
            product: "homeowners"
        },
    };

    const skipOnResumeIf = () => {
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {
        
            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'hoAddtlInfoToQuote') {
                return false;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.value.isBundle_ML
                && submissionVM.value.baseData.status_ML !== 'Draft') {
                return true;
            }

            return true;
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited() || disableReturnToQuoteButton}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyfootercomponent'
            showReturnToQuote={showReturnToQuote && canRequote}
            disableReturnToQuote={!canRequote || disableNextButton}
            disableNext={disableNextButton}
            updateWizardData={updateWizardData}
            validateData={validateData}
            history={history}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

HOAdditionalInfoToQuote.propTypes = wizardProps;

export default withRouter(HOAdditionalInfoToQuote);